module.exports = __webpack_public_path__ + "static/media/SmartShop_8-800w.2af0980d.png";